const navbar = document.querySelector('.js-navbar');
const desktopNavReveal = 120;
let previousScrollPos = window.pageYOffset;
let ticking = false;

function hideNavigation() {
  navbar.classList.remove('is-active');
}

function showNavigation() {
  if (navbar.className === 'is-active') {
    return;
  }

  const currentScrollPos = window.pageYOffset;
  if (currentScrollPos < desktopNavReveal) {
    return;
  }

  navbar.classList.add('is-active');
}

function init() {
  document.addEventListener('scroll', () => {
    const currentScrollPos = window.pageYOffset;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        if ((previousScrollPos < currentScrollPos) || (currentScrollPos < desktopNavReveal)) {
          hideNavigation();
        } else {
          showNavigation();
        }
        previousScrollPos = currentScrollPos;
        ticking = false;
      });
      ticking = true;
    }
  });
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/default/navigation/_navbar/mando-ui.navbar.js